<template>
  <span>{{ props.staticValue }}</span>
</template>

<script lang="ts" setup>
const props = defineProps({
  staticValue: {
    type: String,
    default: "5696393",
  }
})

</script>